<file-pond #myPond
		   [ngClass]="extraClass"
		   [options]="pondOptions"
		   (oninit)="pondHandleInit()"
		   (onpreparefile)="pondHandlePrepareFile($event)"
		   (onprocessfile)="pondHandleProcessFile($event)"
		   (onaddfilestart)="loading.emit(true)"
		   (onremovefile)="removeFile()"
		   (onprocessfileprogress)="processFileProgress.emit($event)"></file-pond>
